module.exports = __webpack_public_path__ + "img/y_2011_hover.57586f54.png";